import React,
{
    useState,
    useEffect
} from "react";
import axios from "axios";
import UserForm
    from "./UserForm";
import Modal from 'react-bootstrap/Modal';
import Spinner from 'react-bootstrap/Spinner';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';

const FACILITY = process.env.REACT_APP_INTELLIO_FACILITY;
const API_IP = `https://${FACILITY}.intellio-dev.com/api`;
const HOPEWELL_IP = `https://hopewell.intellio-dev.com/api`;
const CHRMC_IP = `https://chrmc.intellio-dev.com/api`;

const IS_DOWN = false;

const BadgeRegistration = (props) => {
    const [override, setOverride] = useState(false);
    const [isRegistered, setIsRegistered] = useState(false);
    const [isComplete, setIsComplete] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isAuthorized, setIsAuthorized] = useState(false);
    const [initFormValues, initSetFormValues] =
        useState(
            {
                firstname: '',
                lastName: '',
                role: '',
                unit: '',
                roles: [],
                units: [],
                serial: ''
            }
        );

    const [show, setShowModal] = useState(false);
    const handleCloseModal = () => setShowModal(false);
    const handleSubmitPassword = (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.stopPropagation();
        } else {
            setIsLoading(true);
            const password = event.target[0].value;
            const urlParams = new URLSearchParams(window.location.search);
            const token = urlParams.get('token');
            axios
                .post(
                    API_IP + "/authorization",
                    { password },
                    { params: {token}}
                )
                .then((res) => {
                    setIsLoading(false);
                    setShowModal(false);
                    if (res.status === 200) {
                        alert("Password Correct");
                        setIsRegistered(false);
                        setOverride(true);
                    } else {
                        alert(res);
                        event.stopPropagation();
                    }
                })
                .catch(
                    (err) => {
                        setIsLoading(false);
                        event.stopPropagation();
                        if (err.status === 401) {
                            alert("Authorization failed");
                        } else if (err.status === 400) {
                            alert("User already registered");
                        } else {
                            alert(err);
                        }
                    }
                        
                );
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.stopPropagation();
        } else {
            setIsLoading(true);
            setIsComplete(false);
            if (isRegistered) {
                event.stopPropagation();
                setIsLoading(false);
                setShowModal(true);
            } else {
                const firstName = event.target[0].value;
                const lastName = event.target[1].value;
                const role = event.target[2].value;
                const unit = event.target[3].value;
                const serial = event.target[4].value;
                const formData = {
                    firstName,
                    lastName,
                    role,
                    unit,
                    serial,
                    override
                };
                const urlParams = new URLSearchParams(window.location.search);
                const token = urlParams.get('token');
                console.log("submitting form data: ", formData);
                axios
                    .post(
                        HOPEWELL_IP + "/badge-registration",
                        formData,
                        { params: {token}}
                    )
                    .then((res1) => {
                        if (res1.status === 200) {
                            console.log("User successfully registered to Hopewell.");
                        } else {
                            alert(res1);
                        }
                        axios
                            .post(
                                CHRMC_IP + "/badge-registration",
                                formData,
                                { params: {token}}
                            )
                            .then((res2) => {
                                setIsLoading(false);
                                if (res2.status === 200) {
                                    console.log("User successfully registered to CHRMC.");
                                    setIsSuccess(true);
                                } else {
                                    alert(res2);
                                }
                                setIsComplete(true);
                            }).catch((err) => {
                                if (err.status === 401) {
                                    alert("Authorization failed");
                                } else if (err.status === 400) {
                                    alert("User already registered");
                                } else {
                                    alert(err);
                                }
                                setIsLoading(false);
                                setIsComplete(true);
                            });
                    }).catch((err) => {
                        if (err.status === 401) {
                            alert("Authorization failed");
                        } else if (err.status === 400) {
                            alert("User already registered");
                        } else {
                            alert(err);
                        }
                        setIsLoading(false);
                        setIsComplete(true);
                    });
            } 
        }
    };

    // Load data from server and reinitialize user form
    useEffect(() => {
        setIsLoading(true);
        setIsAuthorized(false);
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');
        axios
            .get(
                API_IP + "/form-info?token=" + token
            )
            .then((res) => {
                console.log('/form-info result =', res);
                setIsAuthorized(true);
                setIsLoading(false);
                const formInfo = res.data;
                const firstName = formInfo.firstName;
                const lastName = formInfo.lastName;
                const role = formInfo.role;
                const unit = formInfo.unit;
                const roles = formInfo.roles;
                const units = formInfo.units;
                const serial = formInfo.serial;
                if (firstName) {
                    setIsRegistered(true);
                }
                initSetFormValues(
                    {
                        firstName,
                        lastName,
                        role,
                        unit,
                        roles,
                        units,
                        serial
                    }
                );
            })
            .catch(
                (err) => {
                    setIsLoading(false);
                    alert(err);
                } 
            );
    }, []);

    if (IS_DOWN) {
        return (
            <div className="centered">
                System is temporarily down for maintenance.
            </div>
        );
    }
    else if (isLoading){
        return (
            <div className="centered">
                <Spinner animation="border" variant="info" />
            </div>
        );
    } else {
        if (!isAuthorized) {
            return (
                <div className="centered">
                    Token unauthorized. Contact system administrator.
                </div>
            );
        } else {
            if (isComplete) { 
                if (isSuccess) {
                    return (
                        <div className="centered">
                            Badge registered successfully to all facilities.
                        </div>
                    );
                } else {
                    return (
                        <div className="centered">
                            Error registering badge. Do NOT attempt to register again. Contact system administrator to complete registration.
                        </div>
                    );
                }
                
            } else {
                return (
                    <div>
                        <UserForm
                            initialValues={initFormValues}
                            onSubmit={handleSubmit}
                            isRegistered={isRegistered}>
                        </UserForm>
                        <Modal show={show} onHide={handleCloseModal}>
                            <Modal.Header closeButton>
                                <Modal.Title>Enter password</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Form onSubmit={handleSubmitPassword}>
                                    <Form.Group controlId="password">
                                        <Form.Control
                                            required
                                            type="password"
                                            aria-describedby="passwordHelpBlock"
                                        />
                                        <Form.Text id="passwordHelpBlock" muted>
                                            Badge reassignment is restricted. Contact system administrator to obtain password.
                                        </Form.Text>
                                    </Form.Group>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={handleCloseModal}>
                                            Close
                                        </Button>
                                        <Button variant="info" type="submit">
                                            Reassign Badge
                                        </Button>
                                    </Modal.Footer>
                                </Form>
                            </Modal.Body>
                        </Modal>
                    </div>
                );
            }
        }
    }

};

export default BadgeRegistration;
